import {urlencode} from "./text";

let lastCallbackId = 0;

const installedPackagesMapAndroid = {
  "com.facebook.orca": "facebookm",
  "com.facebook.katana": "facebook",
  "com.instagram.android": "instagram",
  "com.whatsapp": "whatsapp",
  "org.telegram.messenger": "telegram",
  "com.snapchat.android": "snapchat",
  "com.zhiliaoapp.musically": "tiktok",
};

const installedPackagesMapIos = {
  "fb-messenger://": "facebookm",
  "fb://": "facebook",
  "instagram://": "instagram",
  "whatsapp://": "whatsapp",
  "telegram://": "telegram",
  "snapchat://": "snapchat",
  "tiktoksharesdk://": "tiktok",
};

export function webviewBuildCallURL(func, params) {
  const queryPairs = [];

  Object.keys(params).forEach((key) => {
    if (typeof params[key] !== "undefined") {
      queryPairs.push(`${key}=${params[key]}`);
    }
  });

  return `callback:${func}?${queryPairs.join("&")}`;
}

export function webviewCall(func, params) {
  window.location.href = webviewBuildCallURL(func, params);
}

export function webviewCallWithCallback(func, params, cb) {
  const funcName = "webviewFuncCallback_" + lastCallbackId;
  lastCallbackId++;

  window[funcName] = function() {
    if (cb) {
      cb(...arguments);
    }

    delete window[funcName];
  };

  params.func = funcName;

  webviewCall(func, params);
}

// ---

export function webviewOpenBrowser(url) {
  webviewCall("openblank", {url: urlencode(url)});
}

// ---

export function webviewShare(params, cb) {
  webviewCallWithCallback("nativeShare", params, cb);
}

export function webviewShareFacebook(url, imageUrl, hashtag, options, cb) {
  const params = {
    providers: "[2]",
  };

  if (url) {
    params.url = encodeURIComponent(url);
  }

  if (imageUrl) {
    params.imageUrl = encodeURIComponent(imageUrl);
  }

  if (hashtag) {
    params.hashtag = encodeURIComponent(hashtag);
  }

  webviewShare(Object.assign(params, options || {}), cb);
}

export function webviewShareInstagramStory(url, imageUrl, options, cb) {
  const params = Object.assign({
    providers: "[1]",
    url: encodeURIComponent(url),
    imageUrl: encodeURIComponent(imageUrl),
    ig_direct: 1,
    ig_share_to: 'stories',
    close_after_share: 1
  }, options || {});

  webviewShare(params, cb);
}

export function webviewShareInstagramFeed(url, imageUrl, options, cb) {
  const params = Object.assign({
    providers: "[1]",
    url: encodeURIComponent(url),
    imageUrl: encodeURIComponent(imageUrl),
    ig_direct: 1,
    ig_share_to: 'feed',
    close_after_share: 1
  }, options || {});

  webviewShare(params, cb);
}

export function webviewShareSnapchatImage(attachmentUrl, imageUrl, options, cb) {
  const params = Object.assign({
    providers: "[11]",
    imageUrl: encodeURIComponent(imageUrl),
    caption_text: "",
  }, options || {});

  if (attachmentUrl) {
    params.attachment_url = encodeURIComponent(attachmentUrl);
  }

  webviewShare(params, cb);
}

export function webviewShareDownload(imageUrl, cb) {
  const params = {
    providers: "[0]",
    imageUrl: encodeURIComponent(imageUrl)
  };

  webviewShare(params, cb);
}

// ---

export function webviewCheckInstalledApps(cb) {
  if (window.clientConfig.isWebviewIOS) {
    webviewCheckInstalledAppsIos(cb);
  } else {
    webviewCheckInstalledAppsAndroid(cb);
  }
}

function webviewCheckInstalledAppsIos(cb) {
  const packages = Object.keys(installedPackagesMapIos)
    .map((item) => encodeURIComponent(item))
    .join(",");

  webviewCallWithCallback("nativeInstalledApps", {packages: `[${packages}]`}, function(result) {
    result = JSON.parse(result);

    const installedApps = {};
    Object.keys(result.packages).forEach((key) => {
      installedApps[installedPackagesMapIos[key]] = result.packages[key] === 1;
    });

    cb(installedApps);
  });
}

function webviewCheckInstalledAppsAndroid(cb) {
  const packages = Object.keys(installedPackagesMapAndroid).join(",");

  webviewCallWithCallback("nativeInstalledApps", {packages: `[${packages}]`}, function(result) {
    const installedApps = {};
    Object.keys(result.packages).forEach((key) => {
      installedApps[installedPackagesMapAndroid[key]] = result.packages[key] === 1;
    });

    cb(installedApps);
  });
}
